/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingAggregationTrendRequest extends models.BillingAggregationRequest {
    getFixupPrototypeFunction() { return BillingAggregationTrendRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingAggregationTrendRequest>): BillingAggregationTrendRequest {
        let obj = Object.assign(new BillingAggregationTrendRequest(), model);
        BillingAggregationTrendRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingAggregationTrendRequest>): BillingAggregationTrendRequest {
        if (!model) return null;
        return BillingAggregationTrendRequest.newInstance(<BillingAggregationTrendRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingAggregationTrendRequest) {
        if (!obj) return;

        models.BillingAggregationTrendRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingAggregationTrendRequest): boolean {
        if (models.BillingAggregationRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingAggregationTrendRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.granularity === undefined) {
            this.granularity = 0;
        }
    }

    /**
     * Number of seconds between steps
     */
    granularity: number;

    /**
     * If set, results for future dates will be computed based on a forecast.
     */
    compute_forecast: boolean;

}
